import { render, staticRenderFns } from "./TransactionsPage.vue?vue&type=template&id=2b8fe138&scoped=true&"
import script from "./TransactionsPage.vue?vue&type=script&lang=js&"
export * from "./TransactionsPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsPage.vue?vue&type=style&index=0&id=2b8fe138&lang=scss&scoped=true&"
import style1 from "./TransactionsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8fe138",
  null
  
)

export default component.exports